import React from 'react';

import FieldRow from './FieldRow';
import { Toggle } from '../Inputs';
import { ToggleFieldProps } from './types';

import styles from './ToggleField.scss';

export default function ToggleField({ label, onChange: parentChange, ...props }) {
    return (
        <FieldRow {...props}>
            {({ field: { value, name, ...rest }, form: { setFieldValue }, makeLabel }) => (
                <Toggle
                    {...rest}
                    name={name}
                    checked={value}
                    placeholder={makeLabel(label, { className: styles.label })}
                    onChange={(e) => {
                        const normalized = !!e.target.checked;

                        setFieldValue(name, normalized);

                        parentChange && parentChange(name, normalized);
                    }}
                />
            )}
        </FieldRow>
    );
}

ToggleField.propTypes = ToggleFieldProps;
